export default "/images/ee3498da024f146c375c08cfd1c02f89.avif";